import {Component, Input, OnInit} from '@angular/core';
import {DocumentModel} from '../../../models/document.model';
import {DetaillineDTOModel} from '../../../models/detaillineDTO.model';
import {AlertController, ModalController, ToastController} from '@ionic/angular';
import {RandomColors} from '../../../definitions/random-colors';
import {LokijsService} from '../../../services/database/lokijs.service';
import {FindEquipmentPriceService} from '../../../services/find-equipment-price.service';
import {GeneralService} from '../../../services/general.service';
import {RefreshdatabaseService} from '../../../services/database/refreshdatabase.service';

@Component({
    selector: 'app-equipment-select-scaffolding',
    templateUrl: './equipment-select-scaffolding.page.html',
    styleUrls: ['./equipment-select-scaffolding.page.scss'],
})
export class EquipmentSelectScaffoldingPage implements OnInit {

    @Input() document: DocumentModel;
    @Input() detailLine: DetaillineDTOModel;
    level = 1;
    queryText = '';
    deptList: any[];
    groupList: any[];
    equipList: any[];
    fromDate: string;
    toDate: string;
    canUserEdit: boolean;

    constructor(private modalController: ModalController,
                private randomColors: RandomColors,
                private lokiJs: LokijsService,
                private toastController: ToastController,
                private alertController: AlertController,
                private findEquipmentPriceService: FindEquipmentPriceService,
                private generalServices: GeneralService,
                private refreshDB: RefreshdatabaseService) {
    }

    async ngOnInit() {
        this.deptList = await this.lokiJs.getCollection('hireDept').chain().simplesort('descr').data();
        console.log(this.deptList);
        // Variable to be used as user permission (might be needed)
        this.canUserEdit = true;

        if (this.document.detailLines.length > 0) {
            this.fromDate = this.document.detailLines[0].fromDate;
            this.toDate = this.document.detailLines[0].toDate;
        } else {
            this.fromDate = this.document.scheduledDate;
            this.toDate = this.document.scheduledDate;
        }
    }

    ionViewWillEnter() {
        for (const depto of this.deptList) {
            depto.count = 0;
            this.populateDeptEquipList(depto);
        }
    }

    cancelModal() {
        if (this.level === 2 && this.equipList.length > 0) {
            this.addScaffoldingEquip();
            this.ionViewWillEnter();
        }
        if (this.level > 1) {
            this.level--;
            if (this.level === 2 &&
                !(this.groupList)) {
                this.level--;
            }
        } else {
            this.modalController.dismiss();
        }
    }

    pickColor(i: number) {
        if (i >= this.randomColors.colors.length) {
            i = i - this.randomColors.colors.length;
        }
        return this.randomColors.colors[i];
    }

    async refineToGroup(d: any) {
        this.level++;
        this.equipList = [];
        console.log(this.equipList);
        this.groupList = this.lokiJs.getCollection('hireDeptGroup').chain().find({'hireDept': d.nsuk}).simplesort('descr').data();
        console.log(this.groupList);
        let data: any;
        for (const g of this.groupList) {
            data = await this.lokiJs.getCollection('equipment')
                .chain().find({'group': g.nsuk}).simplesort('description').data();
            if (data) {
                const dataClone = JSON.parse(JSON.stringify(data));
                for (const bit of dataClone) {
                    console.log(bit);
                    bit.overrideDescriptionNote = bit.description;
                    this.equipList.push(bit);
                }
            }
        }
        this.populateQuantities();
        console.log(this.equipList);
    }

    fetchEquipment(event) {
        this.refreshDB.refreshPlantHireResource();
        setTimeout(() => {
            console.log('Async operation has ended');
            event.target.complete();
        }, 2000);
    }

    addScaffoldingEquip() {
        let found: boolean;
        for (const selectedEquip of this.equipList) {
            found = false;
            const cloneSelectedEquip = JSON.parse(JSON.stringify(selectedEquip)) as DetaillineDTOModel;
            for (const equip of this.document.detailLines) {
                if (equip.pdesc === selectedEquip.pdesc) {
                    found = true;
                    if (selectedEquip.qty <= 0) {
                        this.document.detailLines.splice(this.document.detailLines.indexOf(equip), 1);
                    } else {
                        equip.qty = selectedEquip.qty;
                    }
                    break;
                }
            }
            if (!found && (selectedEquip.qty && selectedEquip.qty > 0)) {
                // TODO change this into a new datepicker
                cloneSelectedEquip.fromDate = new Date().toISOString();
                cloneSelectedEquip.toDate = new Date().toISOString();
                this.document.detailLines.push(cloneSelectedEquip);
            }
        }
    }

    populateQuantities() {
        for (const selectedEquip of this.equipList) {
            for (const equip of this.document.detailLines) {
                if (equip.pdesc === selectedEquip.pdesc) {
                    selectedEquip.qty = equip.qty;
                }
            }
        }
    }

    populateDeptEquipList(depto) {
        let count = 0;
        for (const line of this.document.detailLines) {
            const originalEquip = this.lokiJs.getCollection('equipmentdistinctpdesc').chain().find({pdesc: line.pdesc}).data();
            const group = this.lokiJs.getCollection('hireDeptGroup').chain().find({'nsuk': originalEquip[0].group}).data();
            const dept = this.lokiJs.getCollection('hireDept').chain().find({'nsuk': group[0].hireDept}).simplesort('nsuk').data();
            if (dept[0].nsuk === depto.nsuk) {
                count++;
            }
        }
        depto.count = count;
    }
}
